import { once, run } from './electron';

export type DirectoryDialogRow = {
  path: string;
  files?: string[];
  dirSize?: number;
};

/** IPC replies with `[{ path, files, dirSize }]` — not `{ filePaths }`. */
export const parseDirectoryDialogResult = (result: unknown): string | null => {
  if (!Array.isArray(result) || result.length === 0) return null;
  const path = (result[0] as DirectoryDialogRow | undefined)?.path;
  return typeof path === 'string' && path.trim() ? path : null;
};

export const pickDirectory = (options?: {
  title?: string;
  buttonLabel?: string;
}): Promise<string | null> =>
  new Promise((resolve) => {
    once('open-directory-dialog', (result: unknown) => {
      resolve(parseDirectoryDialogResult(result));
    });
    run('open-directory-dialog', {
      options: ['openDirectory', 'createDirectory', 'promptToCreate'],
      ...options,
    });
  });
